import { Grid } from '@mui/material';
import { getCompletedDataDate, getGraphDateRange } from '../../../../utils/getDate';
import { modifiedDateString, percentage } from '../../../../utils/methods';
import FeatureUsageInfo from '../FeatureUsageGraph/FeatureUsageInfo';
import FeatureUsageGraph from '../FeatureUsageGraph/FeatureUsageGraph';
import { featureUsageModeConst } from '../../../../sections/AccountList/accountListConfig';
import FeatureUsageInfoCard from '../FeatureUsageGraph/FeatureUsageInfoCard';

function FeatureUsageBody(props) {
  const {
    feature, accountCount, userCountLen, operationCountLen, siteWideLicense, totalActiveSeats, totalActiveAccounts, getChartData, viewOption, dashboard, graphTitle = null, preview = false,
  } = props;

  const dateRange = getGraphDateRange(viewOption);
  const lastUserCountDate = getCompletedDataDate(Object.keys(feature.userCount || {}), viewOption);
  const lastOperationCountDate = getCompletedDataDate(Object.keys(feature.operationCount || {}), viewOption);
  const lastMonthUserCount = feature.userCount?.[lastUserCountDate];
  const lastMonthOperationCount = feature.operationCount?.[lastOperationCountDate];
  const userPercent = percentage(lastMonthUserCount, totalActiveSeats) || 0;
  const userLastDate = modifiedDateString(lastUserCountDate, viewOption);
  const operationLastDate = modifiedDateString(lastOperationCountDate, viewOption);
  const Info = preview ? FeatureUsageInfoCard : FeatureUsageInfo;
  return (
    <Grid container spacing={4} justifyContent="space-between">
      <Grid item xs={12} sm={preview ? 12 : 2.2}>
        <Info
          siteWideLicense={siteWideLicense}
          totalActiveSeats={totalActiveSeats}
          userPercent={userPercent}
          accountCount={accountCount}
          totalActiveAccounts={totalActiveAccounts}
          used={featureUsageModeConst.USE}
          dontUsed={featureUsageModeConst.DONT_USE}
          dashboard={dashboard}
          feature={feature}
          userLastDate={userLastDate}
          operationLastDate={operationLastDate}
          lastAvailableMonthUserCount={lastMonthUserCount}
          lastAvailableMonthOperationCount={lastMonthOperationCount}
        />
      </Grid>
      <Grid item xs={12} sm={preview ? 12 : 9.8}>
        {userCountLen && operationCountLen && (
          <FeatureUsageGraph
            getChartData={getChartData}
            feature={feature}
            viewOption={viewOption}
            dateRange={dateRange}
            graphTitle={graphTitle}
          />
        )}
      </Grid>
    </Grid>
  );
}

export default FeatureUsageBody;
